<div class="files" *ngIf="status == DONE">
    <!-- show all files with notes -->
    <core-files-list-notes
        [files]="files"
        [file]="selectedFile"
        [notes]="notesCounter"
        [menu]="menu"
        [context]="filesContext"
        (menuClick)="onMenuClick($event)"
        (actionClick)="actionFileClick($event)"
        (iconDownloadClick)="onActionDownloadClick($event)"
    ></core-files-list-notes>
</div>

<div class="version-details-preview-file" *ngIf="files.length > 0" >
    <div *ngFor="let file of files">
        <core-file-notes *ngIf="selectedFile != null && selectedFile.id == file.id && previewStatus == PREVIEW_DONE"
            [file]="selectedFile"
            [urlPrefix]="notesUrlPrefix"
            [urlAnnotationsPrefix]="annotationsUrlPrefix"
            [urlSaveAnnotationsPrefix]="annotationsSaveUrlPrefix"
            [context]="previewContext"
            [canCreateNotes]="canCreateNotes"
            (saved)="onSavedAnnotations($event)"
        ></core-file-notes>
    </div>
    <ng-container *ngIf="selectedFile != null && previewStatus == PREVIEW_LOADING">
        <div class="loader">
            <div class="dimmed">
                <div class="dimmed_box"></div>
                <div class="dimmed_box_large"></div>
            </div>
        </div>

    </ng-container>
</div>

